import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'brand',
		title: 'global.brand',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'name',
		title: 'global.name',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'contributionDate',
		title: 'global.contributionDate',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'startDate',
		title: 'global.emissionStartDate',
		defaultVisible: false,
	},
	{
		accessor: 'endDate',
		title: 'global.emissionEndDate',
		defaultVisible: false,
	},
	{
		accessor: 'quantity',
		title: 'global.quantity',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'priceTTC',
		title: 'global.totalPriceOffset',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'mintStatus',
		title: 'offsets.status',
		type: 'offsetStatus',
		defaultVisible: true,
	},
	{
		accessor: 'blockchain',
		title: 'global.blockchain',
		defaultVisible: false,
		sortable: true,
	},
	{
		accessor: 'organization',
		title: 'global.organization',
		defaultVisible: false,
		sortable: true,
	},
	{
		accessor: 'meanPrice_europertco2eq',
		title: 'global.meanPricePerTone',
		defaultVisible: false,
	},
	{
		accessor: 'tags',
		title: 'global.tags',
		type: 'tags',
		defaultVisible: false,
	},
	{
		type: 'offsetsActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
